import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

import useForm from '../../../lib/hooks/useForm';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const verifyPhoneNumber = ({ verificationCode }) => {
  const data = {
    verification_code: verificationCode,
  };

  return api({
    method: 'post',
    url: '/api/account_settings/validate',
    data,
  });
};

const validationSchema = yup.object({
  verificationCode: yup.string(),
});

const useVerifyPhoneNumber = () => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { mutate } = useMutation(verifyPhoneNumber);
  const { t } = useTranslation('accountSettings');

  const initialValues = {
    verificationCode: '',
  };

  const onSubmit = (values, { resetForm }) => {
    mutate(values, {
      onSuccess: ({ data }) => {
        showSuccess({
          content: data.message,
          title: t('phoneNumberForm.title'),
        });
        queryClient.setQueryData(['accountSettings'], data.settings);
        resetForm();
      },
    });
  };

  const form = useForm({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  return {
    verifyPhoneNumber: form.handleSubmit,
    handleVerificationCode: form.handleChange,
    verificationCode: form.values.verificationCode,
  };
};

export default useVerifyPhoneNumber;
